var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slider',{class:_vm.conditionalClasses,attrs:{"value":_vm.speed,"label":_vm.label,"min":1,"max":5,"tick-labels":_vm.reactiveTickLabels},on:{"input":_vm.handleSpeedChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }